export default "__VITE_ASSET__4a8e5ef5__"